import { putQueryParam, toUrlT } from '@execonline-inc/url';
import { Decoder } from 'jsonous';
import { Task } from 'taskarian';
import { callApi } from '../../../../Appy';
import { Link } from '../../../../Resource/Types';
import { TypeaheadResource, TypeaheadState, error, loaded } from '../Types';

const addQueryParam =
  (query: string) =>
  (link: Link): Task<any, Link> =>
    toUrlT(link.href)
      .map(putQueryParam('q', query))
      .map((url) => ({ ...link, href: url.href }));

export const fetchSuggestions = <T>(
  endpoint: Link,
  query: string,
  setState: (state: TypeaheadState<T>) => void,
  decoder: Decoder<TypeaheadResource<T>>,
): void => {
  Task.succeed(endpoint)
    .andThen(addQueryParam(query))
    .andThen(callApi(decoder, {}))
    .fork(
      (err) => {
        console.error('Failed to fetch typeahead suggestions:', err);
        setState(error(query, 'Failed to load suggestions'));
      },
      (resource) => {
        setState(loaded(query, resource.payload.suggestions));
      },
    );
};
